<template>
  <div
    data-animate="fade-up"
    :class="alignClass"
    class="max-w-3xl"
  >
    <atomic-eyebrow
      v-if="kicker"
      :label="kicker"
    />

    <h2
      class="text-balance text-4xl font-display font-bold tracking-tight text-gray-900 sm:text-5xl"
      :class="{ 'mt-4': kicker }"
    >
      {{ title }}
    </h2>

    <p class="mt-6 text-lg/8 text-gray-600">
      <slot name="description">{{ description }}</slot>
    </p>
  </div>
</template>

<script setup lang="ts">
import type { SectionHeadingProps } from 'types/section'

const { align = 'left' } = defineProps<SectionHeadingProps>()

const alignClass = computed(() => {
  return align === 'center' ? 'mx-auto text-center' : ''
})
</script>
